import { Button, Container, Divider, Paper, Toolbar, Typography } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { React, useRef } from "react";
import { useCongress } from "../hooks";
import PoliciesViewer from "./PoliciesViewer";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    backgroundImage: ({ cover }) => `url(${cover})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "-webkit-background-size": "cover",
    "-moz-background-size": "cover",
    "-o-background-size": "cover",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column"
  },
  container: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: theme.spacing(16),
    paddingBottom: theme.spacing(3)
  },
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3)
  },
  logo: {
    width: "100%",
    height: "100%",
    borderRadius: "8px"
  },
  logoContainer: {
    height: "120px",
    width: "120px",
    transform: "translate(0, -50%) translate(0, -24px)"
  },
  title: {
    marginTop: theme.spacing(-7),
    textAlign: "center"
  },
  fullWidthDivider: {
    width: "calc(100% + 48px)",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  footerBar: {
    marginTop: "auto"
  },
  footerBarSpace: {
    flexGrow: 1
  }
}));

const LoginLayout = ({ children }) => {
  const { congress } = useCongress();
  const classes = useStyles(congress);

  const policiesViewerRef = useRef({ current: {} });

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Container maxWidth="sm" component="main" className={classes.container}>
        <Paper className={classes.content}>
          <Paper className={classes.logoContainer}>
            <img src={congress.logo} alt={congress.name} className={classes.logo} />
          </Paper>
          <Typography variant="h4" className={classes.title}>
            <strong>{congress.name}</strong>
          </Typography>
          <Typography variant="subtitle1">
            {moment(congress.startAt).format("DD/MM/YYYY")}
            &nbsp;-&nbsp;
            {moment(congress.endAt).format("DD/MM/YYYY")}
          </Typography>
          <Divider className={classes.fullWidthDivider} />
          {children}
        </Paper>
      </Container>

      <footer className={classes.footerBar}>
        <Toolbar>
          <Typography className={classes.footerBarSpace} />
          <Button
            color="primary"
            onClick={() => {
              policiesViewerRef.current.setOpenPrivacyPolicy(true);
            }}
          >
            Privacy Policy
          </Button>
          <Button
            color="primary"
            onClick={() => {
              policiesViewerRef.current.setOpenCookiePolicy(true);
            }}
          >
            Cookie Policy
          </Button>
        </Toolbar>
      </footer>

      <PoliciesViewer policiesViewerRef={policiesViewerRef} />
    </div>
  );
};

export default LoginLayout;
